import { csl } from "@pressmedia/webappbase";

export default {
	/**
	* アクティブなシートの取得
	*/
	getActiveSheet() {
		return this.getState("activeSheet");
	},
	
	/**
	* アクティブなシートのインデックス取得
	*/
	getActiveSheetIdx() {
		return this._activeSheetIdx;
	},
	
	/**
	* アクティブなシートの切り替え
	* @param {Integer | string} arg: getSheetに準ずる
	*/
	async setActiveSheet(arg) {
		const currentActive = this.getActiveSheet();
		const newActive = this.getSheet(arg);
		
		if(!newActive) {
			csl.log.grey(
				`${this.getAddress()}:setActiveSheet - no target sheet. selector:`,
				arg
			);
			return false;
		}
		
		if(currentActive === newActive) {
			csl.log.grey(
				`${this.getAddress()}:setActiveSheet - \`${newActive.name}\` is already active.`,
				currentActive
			);
			return false;
		}
		
		await Promise.all([
			!!currentActive && currentActive.setState("visible", false),
			newActive.setState("visible", true),
			this.setState("activeSheet", newActive),
			// 拡張性を持たせるため、changeSheetイベントをトリガーする
			this.$self.trigger("changeSheet", [currentActive, newActive])
		]);
		
		this._activeSheetIdx = this.getSheet().indexOf(newActive);
		return this._activeSheetIdx;
	}
};
